///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../../../baseClasses/dataMaintenance.interface.ts"/>
///<reference path="../../../../plugins/reports/reports.models.ts"/>
///<reference path="../common/collection-api.ts"/>


module Meevo.Components.Controls.SmartMover {
    import IReportService = Meevo.Plugins.Reports.IReportService;


    export class ReportServicesCollection extends SmartMoverApiCollection<IReportService> implements IApiCollection<IReportService> {

        get url() {
            return 'report/Service';
        }

        constructor(connectedModel: ModelValueType[], items: IReportService[] = [], options: ICollectionOptions<IReportService> = {}) {
            super(connectedModel, items, options);

            this.updateCriteria({
                genderEnumList: [92, 93, 94, 2035],
                fieldOrderBy: 'DisplayName',
                objectStateEnumList: [2026, 2027],
                orderAscDesc: 'Ascending',
                serviceCategoryList: []
            });
        }
    }

}
